import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { PostCategory } from '@/types/NewsFeed.ts'
import { DELETE_POST_CATEGORY } from '@/modules/API/news/news.ts'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../newsSettings.module.scss'

interface ConfirmDeletePostCategoryDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    category: PostCategory
    refetch: () => void
}

const ConfirmDeletePostCategoryDialog: FunctionComponent<ConfirmDeletePostCategoryDialogProps> = ({
    open,
    handleClose,
    daycareId,
    category,
    refetch
}: ConfirmDeletePostCategoryDialogProps) => {
    const { t } = useTranslation()
    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deletePostCategory] = useMutation(DELETE_POST_CATEGORY, {
        variables: {
            daycareId,
            postCategoryId: category.id
        },
        onCompleted: () => {
            refetch()
            showNotificationSuccess(t('postCategoryDeleted'))
            handleClose()
        },
        onError: () => {
            showNotificationError(t('postCategoryDeletedError'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('deletePostCategory')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextContainer}>
                    <p className={styles.Text}>
                        {t('deletePostCategoryMessage')} <span>{category.name}</span> ?{' '}
                    </p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={() => deletePostCategory()}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeletePostCategoryDialog
